import { Component, OnInit } from '@angular/core';
import { ViewEncapsulation } from '@angular/core';
import { OperatorsService } from '../../services/operators/operators.service';
import { NgbModal} from '@ng-bootstrap/ng-bootstrap';
import { Validators, FormBuilder, FormGroup } from '@angular/forms';
@Component({
  selector: 'app-operators',
  templateUrl: './operators.component.html',
  styleUrls: ['./operators.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class OperatorsComponent implements OnInit {
  operators: any = [];
  text:any="";
  formGroup:FormGroup;
  itemName: any = [];
  itemDetails: any = [];
  constructor(private as: OperatorsService,private modalService: NgbModal,private fb:FormBuilder) {
    this.as.getOperators(1,this.text).subscribe((res) => {
      if (res.status == true) {
        this.operators = res.data;
      }
    })
  }
  open(content) {
    this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title'});
  }
  ngOnInit() {}
  operatorsEdit(item,content){
    this.formGroup=this.fb.group({data:item[1]})
  
    this. open(content);
    this.itemDetails=item
  }
  onPageChange(page){
    this.as.getOperators(page,this.text).subscribe((res) => {
      if (res.status == true) {
        this.operators = res.data;
      }
    })
  }
  search(text){
    this.text=text.value;
    this.as.getOperators(1,this.text).subscribe((res) => {
      if (res.status == true) {
        this.operators = res.data;
      }
    })
  }
  onUpdate(content){
    // this.users[this.itemDetails[0]]=Number(this.formGroup.value.data); 
    // this.as.putAssumption(this.assumptions,this.assumptions._id).subscribe((res) => {
    //   if (res.success == true) {
    //     this.keys=Object.keys(res.data);
    //     this.keys=this.keys.filter((item)=>{
    //         return item!="__v" && item!="_id";
    //     })
    //     this.keys.forEach(item => {
    //       this.itemName.push(item.replace(/_/g," "))
    //     });
    //     this.assumptions = res.data;
    //   }
    // });
  }
}
